// extracted by mini-css-extract-plugin
export default {"tab":"PersonalizationTab_tab__1uxx6"};